import { EntidadeBase } from 'hay-core-react';
class ClassificacaoModel extends EntidadeBase {
  constructor() {
    super('classificacao');
  }
}

export default new ClassificacaoModel();
